import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import useReveal from "../useReveal";
import "./Style.scss";

const Choose = () => {
  const revealRef = useReveal();

  return (
    <section className="homeChoose">
      <Container className="homeChoose__inner homeReveal" ref={revealRef}>
        <Row className="g-3 g-lg-4">
          <Col md={6}>
            <article className="homeChoose__panel homeChoose__panel--soft">
              <span className="homeChoose__icon" aria-hidden="true">
                <i className="fas fa-handshake" />
              </span>
              <h3>Business With Us</h3>
              <p className="homeChoose__eyebrow">Ready to partner?</p>
              <p>
                Grow with a broking partner. Refer clients, earn a share of
                brokerage on their trades, and unlock incentives as your network
                expands.
              </p>
              <Link to="/contact" className="homeCtaPrimary">
                Partner With Us
              </Link>
            </article>
          </Col>
          <Col md={6}>
            <article className="homeChoose__panel homeChoose__panel--teal">
              <span className="homeChoose__icon" aria-hidden="true">
                <i className="fas fa-rocket" />
              </span>
              <h3>Start Trading</h3>
              <p className="homeChoose__eyebrow">Your market journey starts here</p>
              <p>
                Open your trading and demat account online and get started with
                Algoquant Global — clear steps, digital onboarding, dedicated
                support.
              </p>
              <div className="homeChoose__actions">
                <Link to="/step-by-step" className="homeChoose__btnLight">
                  Open Account
                </Link>
                <Link to="/contact" className="homeChoose__btnOutline">
                  Contact Us
                </Link>
              </div>
            </article>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Choose;
